export const regex = {
  "99": "sembilan sembilan",
  "hotel": "otel",
  "receptionist": "resepsionis",
  "housekeeping": "auskiping",
  "housekeeper": "auskiper",
  "bellboy": "belboe",
  "kitchen": "kicen",
  "steward": "cued",
  "room": "rum",
  "book": "buk",
  "villa": "pila",
  "suite": "suit",
  "bar": "bar",
  "restaurant": "restoran",
  "merchandise": "mercendais",
  "market": "market",
  "souvenir": "sopenir",
  "booking": "buking",
  "rent": "ren",
  "downpayment": "donpemen",
  "traditional": "tradisional",
  "beach": "bij",
  "surfing": "serping",
  "guest": "ges",
  "house": "aus",
  "vacation": "pekesien",
  "holiday": "olide",
  "tourist": "turis",
  "travel": "trepel",
  "domestic": "domestik",
  "airport": "erpot",
  "culinare": "kuliner",
  "healing": "iling",
  "waiter": "weter",
  "waitress": "wetris",
  "spa": "sepa",
  "massage": "masas",
  "buffet": "bapet",
  "tour": "tur",
  "visit": "pisit",
  "shopping": "soping",
  "village": "pilej",
  "bedroom": "bedrum",
  "twinbed": "twinbed",
  "cafe": "kapx",
  "driver": "draiper",
  "luggage": "lagij",
  "accomodation": "akomodesien",
  "advanture": "edpencer",
  "resort": "risot",
  "checkin": "cekin",
  "checkout": "cekaut",
  "out": "aut",
  "trip": "trip",
  "guide": "gaid",
  "service": "serpis",
  "amenities": "amenitis",
  "attraction": "etreksien",
  "complimentary": "komplimentari",
  "breakfast": "brikpes",
  "double": "dabel",
  "deposit": "deposit",
  "front": "pron",
  "desk": "des",
  "manager": "menejer",
  "gardener": "gardener",
  "therapist": "terapis",
  "pool": "pul",
  "cart": "kat",
  "motel": "motel",
  "lobby": "lobi",
  "reservation": "reserpesien",
  "view": "piyu",
  "art": "at",
  "gallery": "galeri",
  "monument": "monumen",
  "ritual": "rituwal",
  "voucher": "pocer",
  "recommend": "rekomen",
  "recommended": "rekomendid",
  "relax": "rileks",
  "agency": "xjensi",
  "expedition": "ekspedisien",
  "sightseeing": "saitsiying",
  "landing": "landing",
  "takeoff": "tekop",
  "passenger": "pesenjer",
  "suitcase": "sutkes",
  "journey": "jurne",
  "season": "sisen",
  "local": "lokal",
  "people": "pipel",
  "sunrise": "sanrais",
  "sunset": "sanset",
  "museum": "musium",
  "grand": "gren",
  "festival": "pestipal",
  "accreditation": "akreditaxsien",
  "ecotourism": "ekoturisem",
  "adventure": "edpencer",
  "afterdeparture": "apter departur",
  "charge": "cas",
  "agent": "xjen",
  "air": "er",
  "sea": "si",
  "airline": "erlain",
  "fare": "per",
  "assets": "aset",
  "auditing": "oditing",
  "backpacker": "bxkpexker",
  "benchmarking": "bxnjmarking",
  "biodiversity": "bayodipersiti",
  "charter": "carter",
  "coach": "kouj",
  "city": "siti",
  "commercial": "komersial",
  "rate": "rxit",
  "commision": "komisien",
  "configuration": "konpigurxsien",
  "conservation": "konsxrpasien",
  "coupon": "kupon",
  "culture": "kalcer",
  "customer": "kastamer",
  "departure": "dxparcer",
  "tax": "teks",
  "escort": "xskot",
  "exotic": "eksotik",
  "extensions": "ekstensiens",
  "franchise": "prancais",
  "office": "opis",
  "gateway": "getewei",
  "heritage": "heritexj",
  "host": "os",
  "leisure": "leiser",
  "occupancy": "okupansi",
  "overbook": "operbuk",
  "override": "operaid",
  "package": "pexkeixj",
  "pax": "peks",
  "profit": "propit",
  "revenue": "repenyu",
  "expenditure": "ekspenditur",
  "rates": "reits",
  "rooming": "ruming",
  "list": "lis",
  "seasonality": "sisenaliti",
  "delivery": "deliperi",
  "special": "spesial",
  "event": "ipen",
  "stakeholder": "stekolder",
  "supplier": "suplayer",
  "tariff": "tarip",
  "tourism": "turisem",
  "product": "prodak",
  "visa": "pisa",
  "visitors": "pisitors",
  "waitlist": "wxitlis",
  "attendance": "atxnden",
  "shorttime": "sot taim",
  "food": "pud",
  "and": "en",
  "beverage": "bepereij",
  "destination": "dxstinxsyen",
  "employment": "xmploimen",
  "goods": "guds",
  "international": "internasional",
  "the": "de",
  "haven": "hepen",
  "bali": "bali",
  "seminyak": "seminyak",
  "sense": "sens",
  "capital": "kapital",
  "viva": "pipa",
  "dash": "des",
  "three": "tri",
  "brothers": "broder",
  "bungalows": "bungalo",
  "villas": "pila",
  "harris": "aris",
  "mercure": "merkur",
  "favehotel": "pepotel",
  "brits": "brit",
  "kuta": "kuta",
  "legian": "legian",
  "wirton": "wirton",
  "six": "siks",
  "luxury": "lekseri",
  "ananda": "ananda",
  "sleepwell": "slipwel",
  "destiny": "desteni",
  "boutique": "butik",
  "origin": "orijin",
  "stellar": "stelar",
  "capsules": "kapsuls",
  "point": "poin",
  "oberoi": "oberoi",
  "horison": "horison",
  "samaya": "samaya",
  "pearl": "peur",
  "primebiz": "praimbis",
  "ixora": "isora",
  "one": "wan",
  "aston": "aston",
  "residence": "residens",
  "hard": "had",
  "rock": "rok",
  "loft": "lop",
  "duo": "duo",
  "zuri": "suri",
  "kutabex": "kutabeks",
  "euphoria": "euporia",
  "central": "sentral",
  "park": "pak",
  "suji": "suji",
  "bungalow": "bungalou",
  "alron": "alron",
  "stones": "stons",
  "bahana": "bahana",
  "spazzio": "spasio",
  "palm": "pam",
  "four": "por",
  "points": "poins",
  "by": "bai",
  "sheraton": "seraton",
  "whiz": "wis",
  "crystal": "kristal",
  "bay": "bai",
  "nusa": "nusa",
  "dua": "dua",
  "nest": "nes",
  "ibis": "ibis",
  "styles": "stail",
  "benoa": "benoa",
  "tropic": "tropik",
  "club": "kleb",
  "med": "med",
  "inn": "in",
  "plagoo": "plagu",
  "suites": "suit",
  "bumbu": "bumbu",
  "white": "wait",
  "lodge": "loj",
  "garden": "garden",
  "paradise": "peredais",
  "castle": "kastel",
  "jepun": "jepun",
  "homestay": "omstae",
  "siesta": "siesta",
  "bliss": "blis",
  "surfer": "serper",
  "borough": "boro",
  "capsule": "kapsul",
  "livio": "libio",
  "berry": "beri",
  "biz": "bis",
  "road": "rut",
  "alam": "alam",
  "kulkul": "kulkul",
  "swiss-belresort": "suis",
  "watu": "belrisot",
  "jimbaran": "watu",
  "prama": "prama",
  "sanur": "sanur",
  "kayangan": "kayangan",
  "intercontinental": "interkontinental",
  "maya": "maya",
  "hyatt": "hayet",
  "regency": "rejensi",
  "mahagiri": "mahagiri",
  "palace": "peles",
  "abian": "abian",
  "harmony": "armoni",
  "linda": "linda",
  "aleesha": "alisya",
  "prime": "praim",
  "plaza": "plasa",
  "sudamala": "sudamala",
  "mall": "mol",
  "maison": "meson",
  "aurelia": "orelia",
  "akana": "akana",
  "sativa": "satipa",
  "cottages": "kotej",
  "asoka": "asoka",
  "sadana": "sadana",
  "guesthouse": "gesaus",
  "bakung": "bakung",
  "ubud": "ubud",
  "alaya": "alaya",
  "amarea": "amareya",
  "ini": "ini",
  "vie": "bi",
  "hospitality": "ospitaliti",
  "evitel": "epitel",
  "best": "bes",
  "western": "westen",
  "premier": "premiyer",
  "agung": "agung",
  "biyukukung": "biyukukung",
  "soca": "soka",
  "umah": "umah",
  "dangin": "dangin",
  "green": "grin",
  "bird": "bed",
  "calma": "kalma",
  "novotel": "nopotel",
  "ion": "iyon",
  "nikko": "niko",
  "mirage": "miras",
  "thalasso": "talaso",
  "core": "kor",
  "conrad": "konrat",
  "aventus": "apentus",
  "garasi": "garasi",
  "secret": "sikrit",
  "rooftop": "ruptop",
  "paon": "paon",
  "nature": "natur",
  "warung": "warung",
  "in": "in",
  "salt": "salet",
  "burger": "berger",
  "murder": "murder",
  "giridhari": "giridari",
  "vegetarian": "pejetariyan",
  "evolution": "epolusien",
  "restauran": "restoran",
  "wild": "wail",
  "flour": "plor",
  "pala": "pala",
  "soleil": "soleyil",
  "at": "et",
  "mulia": "mulia",
  "clover": "kloper",
  "istanbul": "istanbul",
  "corner": "korner",
  "laguna": "laguna",
  "ganesha": "ganesa",
  "rose": "ros",
  "santorini": "santorini",
  "greek": "grik",
  "flavours": "pleber",
  "stakz": "stak",
  "grill": "gril",
  "fat": "pet",
  "tony's": "toni",
  "jamie": "jemi",
  "oliver": "oliber",
  "golden": "golden",
  "lotus": "lotus",
  "chinese": "cainis",
  "seafood": "sipud",
  "breeze": "bris",
  "boardwalk": "bodwok",
  "coconut": "kokenat",
  "bene": "bene",
  "gala": "gala",
  "more": "mor",
  "crumb": "kram",
  "coaster": "koster",
  "riva": "riba",
  "jack": "jek",
  "burgerax": "bergereks",
  "bluefin": "blupin",
  "japanese": "japanis",
  "fusion": "pusien",
  "lounge": "long",
  "sushi": "susi",
  "tei": "te",
  "beachwalk": "bijwok",
  "codegrafiti": "kodgrapiti",
  "alleycats": "alekets",
  "new": "nyu",
  "delhi": "delhi",
  "indian": "indian",
  "bloom": "blum",
  "plantation": "plantasion",
  "zibiru": "jibiru",
  "seasalt": "sisalet",
  "circus": "sirkus",
  "taco": "tako",
  "mexican": "meksikan",
  "junction": "jangsien",
  "backyard": "bekyad",
  "gosha": "gosya",
  "kingsway": "kingsuwe",
  "wahaha": "wahaha",
  "pork": "pok",
  "ribs": "ribs",
  "island": "ailen",
  "on": "on",
  "cabin": "kebin",
  "orchard": "orkad",
  "groove": "grub",
  "bamboo": "bambu",
  "ginger": "jinjer",
  "moon": "mun",
  "moonlite": "munlait",
  "hibiscus": "hibiskus",
  "pirate": "payret",
  "dinner": "diner",
  "cruise": "krus",
  "este": "este",
  "gusto": "gusto",
  "gelato": "jelato",
  "&": "en",
  "caffe": "kape",
  "paperboy": "peperboi",
  "cosmic": "kosmik",
  "diner": "diner",
  "labak": "labak",
  "sari": "sari",
  "pistachio": "pistasio",
  "seasoned": "sisen",
  "fiesta": "piyesta",
  "avocado": "apokado",
  "terracotta": "terakota",
  "simply": "simpli",
  "social": "sosial",
  "kayunan": "kayunan",
  "coffee": "kopi",
  "locavore": "lokabor",
  "luis": "luis",
  "pakan": "pakan",
  "star": "star",
  "tablespoon": "tebelspun",
  "pomegranate": "pomegranat",
  "nostimo": "nostimo",
  "sweet": "suit",
  "orange": "orxn",
  "naughty": "noti",
  "nuri's": "nuris",
  "casa": "kasa",
  "luna": "luna",
  "twist": "tuis",
  "wanara": "wanara",
  "spice": "spais",
  "tastes": "teis",
  "of": "op",
  "taksu": "taksu",
  "coco": "koko",
  "bistro": "bistro",
  "tanjung": "tanjung",
  "glaze": "gles",
  "sakala": "sakala",
  "bale": "bale",
  "banjar": "banjar",
  "mozzarella": "mosarela",
  "garlic": "garlik",
  "lane": "len",
  "orchid": "orkid",
  "sugar": "suger",
  "rays": "reis",
  "la": "la",
  "monde": "mon",
  "hot": "ot",
  "sexy": "seksi",
  "rice": "rais",
  "paddy": "pedi",
  "rosemary": "rosmeri",
  "fresco": "presko",
  "ocean": "osiyen",
  "terrace": "teras",
  "moomoo's": "mumus",
  "steakhouse": "stikaus",
  "safari": "sapari",
  "marine": "marin",
  "monkey": "mongki",
  "forest": "pores",
  "munduk": "munduk",
  "moding": "moding",
  "taman": "taman",
  "edelweiss": "edelweis",
  "pinggan": "pinggan",
  "hidden": "iden",
  "canyon": "kanyon",
  "beji": "beji",
  "guwang": "guwang",
  "lahangan": "laangan",
  "water": "woter",
  "slide": "slaid",
  "lemukih": "lemukih",
  "mara": "mara",
  "natya": "natya",
  "river": "riper",
  "sidemen": "sidemen",
  "glamping": "glemping",
  "kara": "kara",
  "home": "om",
  "living": "liping",
  "cave": "kep",
  "ritatkala": "ritatkala",
  "honeymoon": "animun",
  "mailroom": "meilrum",
  "octagon": "oktagon",
  "lake": "lek",
  "oculus": "okulus",
  "waterbom": "waterbum",
  "gracious": "grasiyus",
  "project": "projek",
  "pemulan": "pemulan",
  "farm": "pam",
  "cooking": "kuking",
  "school": "skul",
  "republic": "republik",
  "soap": "sop",
  "kuber": "kuber",
  "pakerisan": "pakerisan",
  "tubing": "tubing",
  "sanctoo": "sangto",
  "wellness": "welnes",
  "permata": "permata",
  "ayung": "ayung",
  "private": "praipet",
  "estate": "estet",
  "locca": "loka",
  "mari": "mari",
  "radiantly": "radianli",
  "alive": "elaip",
  "morning": "morning",
  "light": "lait",
  "yoga": "yoga",
  "john": "jon",
  "hardy": "ardi",
  "kynd": "kain",
  "community": "komuniti",
  "neon": "neon",
  "palms": "palem",
  "nook": "nuk",
  "mrs": "mirsis",
  "sippy": "sipi",
  "potato": "potato",
  "head": "hed",
  "mano": "mano",
  "mexicola": "meksikola",
  "favela": "papela",
  "kim": "kim",
  "soo": "su",
  "bodyworks": "bodiwok",
  "ki.": "ki",
  "ashiatsu": "asiyatsu",
  "nyaman": "nyaman",
  "beer": "bir",
  "cycle": "saikel",
  "dream": "drim",
  "zone": "son",
  "odysseys": "odisi",
  "surf": "sep",
  "escape": "eskep",
  "pandora": "pandora",
  "experience": "eksperiyens",
  "flowrider,": "plorider,",
  "armada": "armada",
  "flowhouse": "ploaus",
  "turtle": "tartel",
  "society": "sosayeti",
  "genuine": "jenuin",
  "fake": "pek",
  "shop": "sop",
  "center": "senter",
  "pantai": "pante",
  "bowl": "bol",
  "single": "singgel",
  "fin": "pin",
  "roosterfish": "rusterpis",
  "pasifika": "pasipika",
  "flyboarding": "plaibording",
  "di": "di",
  "apollo": "apolo",
  "seawalker": "siwalker",
  "timbis": "timbis",
  "paragliding": "paragliding",
  "blow": "blo",
  "dreamland": "drimlen",
  "mushroom": "masrum",
  "brahma": "brahma",
  "vihara": "piara",
  "arama": "arama",
  "tegalalang": "tegalalang",
  "tegenungan": "tegenungan",
  "waterfall": "waterpol",
  "rafting": "repting",
  "butterfly": "baterple",
  "kertha": "kertha",
  "gosa": "gosa",
  "ambengan": "ambengan",
  "trekking": "treking",
  "desa": "desa",
  "sambangan": "sambangan",
  "angel's": "enjels",
  "billabong": "bilabong",
  "bedugul": "bedugul",
  "turf": "tep",
  "underwater": "anderwater",
  "scooter": "skuter",
  "walk": "wok",
  "hideout": "aidot",
  "karangasem": "karangasem",
  "neka": "neka",
  "blanco": "blangko",
  "renaissance": "renesans",
  "shell": "sel",
  "monumen": "monumen",
  "bajra": "bajra",
  "sandhi": "sandhi",
  "handara": "andara",
  "gate": "geit",
  "splash": "sples",
  "waterpark": "waterpak",
  "savana": "sapana",
  "tianyar": "tianyar",
  "blooms": "blums",
  "banyu": "banyu",
  "wana": "wana",
  "amertha": "amertha",
  "diamond": "daimen",
  "lovina": "lopina",
  "undisan": "undisan",
  "teletubbies": "teletabis",
  "hill": "il",
  "giant": "jayen",
  "banyan": "banyan",
  "trees": "tris",
  "blue": "blu",
  "lagoon": "lagun",
  "ghost": "gos",
  "palace,": "peles,",
  "ice": "ais",
  "cream": "krim",
  "world": "wod",
  "gemitir": "gemitir",
  "sharma": "sarma",
  "springs": "springs",
  "upside": "apsed",
  "down": "daun",
  "pizza": "pija",
  "fried": "praid",
  "chicken": "ciken",
  "friend": "praid",
  "noodle": "nudel",
  "barbecue": "barbekiu",
  "beef": "bip",
  "curry": "kari",
  "crepes": "krepes",
  "doughnut": "donat",
  "croissant": "kroisan",
  "egg": "eg",
  "fish": "pis",
  "chips": "cip",
  "french": "prens",
  "fries": "prais",
  "porridge": "porij",
  "sausage": "sosij",
  "lasagna": "lasanya",
  "carbonara": "karbonara",
  "fettucini": "petucini",
  "macaroon": "makaron",
  "meatball": "mitbol",
  "spagehetti": "sepageti",
  "pancake": "penkeik",
  "popcorn": "popkon",
  "sandwich": "senwij",
  "corndog": "kondog",
  "pudding": "puding",
  "jelly": "jeli",
  "wafers": "waper",
  "waffle": "wapel",
  "cake": "keik",
  "vanilla": "panila",
  "chocolate": "cokolat",
  "strawberry": "stroberi",
  "banana": "banana",
  "split": "split",
  "dry": "drai",
  "ramen": "ramen",
  "spicy": "spaisi",
  "california": "kalipornia",
  "roll": "rol",
  "deep": "dip",
  "creamy": "krimi",
  "volkano": "polkano",
  "roasted": "rosted",
  "salmon": "salmon",
  "chuka": "cuka",
  "wakame": "wakame",
  "sashimi": "sasimi",
  "katsu": "katsu",
  "hotplate": "hotpleit",
  "blackpepper": "blekpeper",
  "omellet": "omelet",
  "don": "don",
  "namazu": "namasu",
  "buri": "buri",
  "gyoza": "gyosa",
  "crispy": "krispi",
  "crab": "kreb",
  "stick": "setiks",
  "honey": "hani",
  "sauce": "saus",
  "nugget": "naget",
  "korean": "korean",
  "soy": "soi",
  "wings": "wing",
  "fillet": "pilet",
  "apple": "apel",
  "pie": "pai",
  "snack": "snek",
  "wrap": "wrep",
  "bites": "bait",
  "corn": "korn",
  "choco": "coko",
  "sundae": "sandae",
  "lemon": "lxmon",
  "klepon": "klepon",
  "lover": "loper",
  "chip": "cip",
  "muffin": "mapin",
  "tuna": "tuna",
  "puff": "pap",
  "pastry": "pastri",
  "cheese": "cis",
  "butter": "bater",
  "scramble": "skrembel",
  "lava": "lapa",
  "pasta": "pasta",
  "bread": "bred",
  "truffle": "trapel",
  "chili": "cili",
  "calamari": "kalamari",
  "meatballs": "mitbols",
  "baked": "bxked",
  "chunks": "cangs",
  "soup": "sup",
  "wedges": "wejes",
  "salad": "salad",
  "pumpkin": "pamkin",
  "duck": "dak",
  "grilled": "griled",
  "spaghettii": "spageti",
  "classic": "klasik",
  "margeritha": "margerita",
  "steam": "stim",
  "clam": "klam",
  "satay": "satai",
  "squid": "skwid",
  "skewer": "skiwer",
  "cookie": "kuki",
  "oatmeal": "otmil",
  "raisin": "raisin",
  "cookies": "kukis",
  "frozen": "prosen",
  "siomay": "siomai",
  "cap": "cap",
  "say": "cai",
  "fu": "pu",
  "yung": "yung",
  "hai": "hai",
  "smashed": "smes",
  "avocados": "apokados",
  "toast": "tous",
  "rolls": "rols",
  "biscuit": "biskit",
  "crackers": "krekers",
  "candy": "kendi",
  "cereal": "sereal",
  "bagel": "begel",
  "almond": "almon",
  "tea": "ti",
  "milk": "milk",
  "wine": "wain",
  "cocktail": "kokteil",
  "champagne": "cempein",
  "milkshake": "milsxk",
  "yogurth": "yoget",
  "juice": "jus",
  "soft": "sop",
  "drink": "dring",
  "whisky": "wiski",
  "smoothies": "smutis",
  "cider": "saider",
  "bubble": "babel",
  "mojito": "mohito",
  "martini": "martini",
  "lemonade": "lemoned",
  "ocha": "oca",
  "blackcurrant": "blekkaren",
  "sprite": "sprait",
  "coca": "koka",
  "cola": "kola",
  "iced": "ais",
  "lychee": "lxici",
  "fruit": "prut",
  "latte": "latx",
  "frappe": "prapx",
  "hazelnut": "haselnat",
  "mocha": "moka",
  "caramel": "karamxl",
  "grass": "grxs",
  "cappucino": "kapucino",
  "long": "long",
  "black": "blek",
  "flat": "plet",
  "matcha": "maca",
  "float": "plout",
  "ovaltine": "opaltin",
  "melon": "melon",
  "peach": "pij",
  "tropical": "tropikal",
  "punch": "panj",
  "mixberry": "miksberi",
  "italian": "italian",
  "soda": "soda",
  "lime": "laim",
  "squash": "skuas",
  "blended": "blended",
  "fanta": "panta",
  "thai": "tai",
  "margarita": "margarita",
  "cosmopolitan": "kosmopolitan",
  "vodka": "podka",
  "tequila": "tekila",
  "rum": "ram",
  "brandy": "brendi",
  "fresh": "pres",
  "brewed": "brud",
  "cold": "kod",
  "brew": "bru",
  "sparkling": "sparkling",
  "mochaccino": "mokacino",
  "mango": "menggo",
  "freeze": "pris",
  "arabic": "arabik",
  "virgin": "pirjin",
  "pina": "pina",
  "colada": "kolada",
  "cappuccino": "kapucino",
  "electrohell": "elektroel",
  "mayhem": "mehem",
  "apparel": "aparel",
  "cfc": "siepsi",
  "j.co": "jeko",
  "silverqueen": "silperkuin",
  "erigo": "erigo",
  "fonte": "ponte",
  "le": "le",
  "minerale": "mineral",
  "mcdonald": "mekdonal",
  "kfc": "keepsi",
  "jfc": "jiepsi",
  "indomie": "indomi",
  "makeover": "mekoper",
  "somethinc": "samting",
  "esqa": "eska",
  "amazon": "amason",
  "microsoft": "mikrosop",
  "appel": "xipel",
  "disney": "disni",
  "nike": "naik",
  "facebook": "pxsbuk",
  "cisco": "cisko",
  "zara": "sara",
  "pull": "pul",
  "bear": "bxr",
  "honda": "onda",
  "hermes": "ermxs",
  "nescafe": "neskape",
  "pampers": "pxmpers",
  "google": "gugel",
  "youtube": "yutup",
  "sony": "soni",
  "philips": "pilips",
  "starbucks": "starbaks",
  "mastercard": "masterkad",
  "paypal": "paipal",
  "spotify": "spotipai",
  "canon": "kxnon",
  "huawei": "uawei",
  "ferrari": "perari",
  "burberry": "burberi",
  "windows": "windos",
  "nokia": "nokiya",
  "oppo": "opo",
  "blackberry": "blekberi",
  "samsung": "samsung",
  "lenovo": "lenopo",
  "xiaomi": "siomi",
  "ericsson": "eriksen",
  "vario": "pario",
  "scoopy": "sekupi",
  "scarlett": "skarlet"
};